import { useEffect, useState } from "react";
import "../Stylesheets/Table/Table.css";
import {Funnel, Search, SortDownAlt, SortUpAlt, Download} from "react-bootstrap-icons";
import OutsideClickHandler from "react-outside-click-handler";
import axios from "axios";
import { useSelector } from "react-redux";

const TableHeader = ({filter, exportHandler, exportLoad, setExportLoad, setModals, setFilter, sortBy, addNewHandler, AddNewButtonIcon, exportButton, adminFilter, withoutAddNew, checkboxes, setNotification}) => {
    const [form, setForm] = useState({keyword: ""});
    const [admins, setAdmins] = useState([]);
    const [showFilterDropdown, setShowFilterDropdown] = useState(false);
    const userRole = useSelector((state) => state.user.role);

    const handlers = {
        searchByKeyword(e){
            e.preventDefault();
            setFilter((prev) => ({...prev, keyword: form.keyword}));
        }
    }

    useEffect(() => {
        axios('/api/extension/v1/admins')
            .then((res) => {
                const data = res.data.data;
                setAdmins([...data]);
            })
            .catch((err) => {
                // setNotification({show: true, type: "error", text: err.response.data.message.en});
                // setTimeout(() => {
                //     setNotification({show: false, title: "", text: ""});
                // }, 3000);
            })
    }, [])

    return (
        <div className="table-header-container">
            <div className="table-head-left-container">
                <form onSubmit={handlers.searchByKeyword}>
                    <div className="form-group search-keyword-box" style={{maxWidth: "300px"}}>
                        <input type="search"placeholder="Enter keyword" onChange={(e) => setForm((prev) => ({...prev, keyword: e.target.value}))} className="form-control" name="keyword"/>
                        <button className="search-button"><Search /></button>
                    </div>
                </form>
                {(!withoutAddNew && (userRole == "admin" || window.location.pathname.includes("/user") || window.location.pathname.includes("/accounts"))) && <button className="add-new-button" onClick={() => {
                    setModals((prev) => ({...prev, createUser: true}));
                    addNewHandler();
                }}><AddNewButtonIcon /><span>Add New</span></button>}
                {exportButton && <button onClick={() => {
                    exportHandler();
                }} disabled={exportLoad} className="export-button"><Download />{exportLoad ? <div className="button-loader"></div> : <span>Export</span>}</button>}
            </div>
            <div className="table-head-right-container">
                <div className="filter-dropdown-container">
                    <div className="filter-dropdown-item" onClick={() => setShowFilterDropdown(true)}><Funnel /> <span>Filter</span></div>
                    {showFilterDropdown && <OutsideClickHandler onOutsideClick={() => setShowFilterDropdown(false)}> <div className="filter-dropdown-content">
                        {window.location.href.includes('users') && <select onChange={(e) => setFilter((prev) => ({...prev, admin_id: e.target.value}))} value={filter.admin_id} className="form-control" style={{marginBottom: "30px"}}>
                            <option value={""}>Select Admin</option>F
                            {admins.map((item) => <option value={item.id} key={item.id}>{item.name} {item.surname}</option>)}
                        </select>}
                        {(window.location.href.includes('accounts') || window.location.href.includes('watchlist') || window.location.href.includes('bids-history') || window.location.href.includes('won-vehicles') || window.location.href.includes("actions-history")) && <select className="form-control" onChange={(e) => setFilter((prev) => ({...prev, auction: e.target.value}))} value={filter.auction} style={{marginBottom: "30px"}}>
                            <option value={""}>Select Auction</option>
                            <option value={"copart"}>Copart</option>
                            <option value={"iaai"}>IAAI</option>
                        </select>}
                        {(window.location.href.includes("bids-history") || window.location.href.includes('won-vehicles') || window.location.href.includes("actions-history")) && <div className="dates-filter">
                            <div className="form-group">
                                <label>Start Date</label>
                                <input type="date" className="form-control" value={filter.start_date} onChange={(e) => setFilter((prev) => ({...prev, start_date: e.target.value}))}/>
                            </div>
                            <div className="form-group">
                                <label>End Date</label>
                                <input type="date" className="form-control" value={filter.end_date} onChange={(e) => setFilter((prev) => ({...prev, end_date: e.target.value}))}/>
                            </div>
                        </div>}
                        <div className="checkbox-filters">
                            {
                                checkboxes && checkboxes.map((checkbox, i) => {
                                    return (<div className="form-group" key={i}>
                                            <input type="checkbox" id={checkbox.name} onChange={(e) => setFilter((prev) => {
                                                return {...prev, [checkbox.name]: e.target.checked}
                                            })} />
                                            <label htmlFor={checkbox.name}>{checkbox.value}</label>
                                        </div>)
                                })
                            }
                        </div>
                    </div></OutsideClickHandler>}
                </div>
                <div className="filter-inline">
                    <label style={{width: "65px"}}>Sort By:</label>
                    {typeof sortBy != "undefined" && <select className="form-control" onChange={(e) => setFilter((prev) => ({...prev, sort_by: e.target.value}))}>
                        {sortBy.length == 0 && <option>Sort By</option>}
                        {sortBy.map((item, k) => <option key={k} value={item.value}>{item.name}</option>)}
                    </select>}
                </div>
                <button className="sort-order-button" onClick={() => setFilter((prev) => ({...prev, sort_order: prev.sort_order == "DESC" ? "ASC" : "DESC"}))}> {filter.sort_order == "DESC" ? <SortDownAlt /> : <SortUpAlt />} </button>
            </div>
        </div>
    )
}

export default TableHeader